<template>
	<div class="search_listing">
		<div class="container">

			<div
				class="title"
				v-html="title"
			></div>

			<ul
				class="filter-cats"
				v-if="show_filter === 'on' && paginatedData.length >= 0 && Object.keys(parsedCategories).length >= 0 && busy != true"
			>

				<div
					class="sort_banner"
					:class="{'no-filter': show_filter === '' || parsedCategories.length <= 1}"
				>

					<p
						class="no-posts"
						v-if="paginatedData.length < 12"
						v-html="'Showing ' + paginatedData.length + ' of ' + filteredCategory.length"
					></p>

					<p
						class="no-posts"
						v-else-if="paginatedData.length >= 12"
						v-html="'Showing 12' + ' of ' + filteredCategory.length"
					></p>

				</div>
			</ul>

			<transition name="fade">
				<div
					class="overlay"
					v-if="busy === true"
				>
					<loading-animation></loading-animation>
				</div>
			</transition>

			<template v-if="busy != true && paginatedData.length != 0">
				<ul class="search_results">

					<li
						v-for="(post, index) in paginatedData"
						:key="index"
					>
						<h3
							v-if="post.title"
							v-html="post.title"
						></h3>
						<p
							v-if="post.excerpt"
							v-html="post.excerpt"
						></p>
						<div class='cta_wrapper'>
							<template v-if="post.post_type_slug != 'benefit_coverage'">
								<tertiary-button
									v-if="post.permalink"
									:label="'Visit ' + post.post_type"
									:link="{
								title: post.title,
								target: '_self',
								url: post.permalink
							}"
								></tertiary-button>
							</template>

							<template v-if="post.post_type_slug === 'benefit_coverage'">
								<tertiary-button
									v-for="(cover, index) in post.coverage_options"
									:key="index"
									:label="'Visit ' + cover.title"
									:link="{
								title: cover.title,
								target: '_self',
								url: cover.permalink
							}"
								></tertiary-button>
							</template>
						</div>
					</li>
				</ul>
			</template>

			<div
				class="no_posts"
				v-if="busy != true && paginatedData.length === 0"
			>
				<div
					class="no_posts_message"
					v-html="no_posts_message"
				></div>

				<div class="no_posts__cta_container">
					<primary-button
						v-if="parsedPrimaryCta"
						:label="parsedPrimaryCta.title"
						:link="parsedPrimaryCta"
						:theme="'light'"
					></primary-button>

					<secondary-button
						v-if="parsedSecondaryCta"
						:label="parsedSecondaryCta.title"
						:link="parsedSecondaryCta"
						:theme="'dark'"
					></secondary-button>
				</div>

			</div>

			<ul
				class="page-numbers"
				v-if="pageCount != 1 && paginatedData.length != 0 && busy != true"
			>
				<li v-if="pageNumber != 0">
					<a
						@click="pageNumber--"
						class="prev page-numbers"
					>
						<div class="arrow_container">
							<chevron-right></chevron-right>

						</div>
						<span>Previous</span>
					</a>
				</li>

				<li
					v-for="(post, index) in pageCount"
					:key="index"
				>
					<a
						@click="pageNumber = index"
						class="page-numbers"
						:class="{ current: index == pageNumber }"
						v-html="index + 1"
					></a>
				</li>

				<li v-if="pageNumber != pageCount - 1">
					<a
						@click="pageNumber++"
						class="next page-numbers"
					><span>Next</span>
						<div class="arrow_container">
							<chevron-right></chevron-right>

						</div>
					</a>
				</li>
			</ul>

		</div>
	</div>
</template>

<script>
// import PostTile from './PostTile.vue';
import ChevronDown from '../../images/arrow-basic.svg';
import ArrowNavyNorm from '../../images/arrow-basic.svg';
import ArrowNavyLong from '../../images/arrow-basic.svg';
import ChevronRight from './ChevronRight.vue';
import LoadingAnimation from './LoadingAnimation.vue';
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';
import TertiaryButton from './TertiaryButton.vue';

export default {
	/* eslint-disable no-undef */

	data() {
		return {
			arrowNavyNorm: ArrowNavyNorm,
			arrowNavyLong: ArrowNavyLong,
			show: false,
			currentFilter: 'all',
			currentSort: 'latest-oldest',
			visible: true,
			pageNumber: 0, // default to page 0
			number_of_posts: this.number_posts_per_page(),
			chevronDown: ChevronDown,
			dropdownClicked: false,
			window: {
				width: 0,
				height: 0,
			},
			busy: false,
		};
	},

	props: {
		size: {
			default: 'one',
		},
		posts: {},
		categories: {},
		show_filter: {},
		show_title: {},
		title: {},
		show_pagination: {},
		show_sort: {},
		data_size: {
			type: Number,
			required: false,
			default: 10,
		},
		posts_per_page: {
			required: true,
		},
		button_type: {
			default: 'normal',
		},
		no_posts_message: {},
		no_search_results_primary_cta: {},
		no_search_results_secondary_cta: {},
		asset_url: {},
	},

	computed: {
		pageCount() {
			let l = this.filteredCategory.length,
				s = this.number_of_posts;
			return Math.ceil(l / s);
		},

		paginatedData() {
			const start = this.pageNumber * this.number_of_posts,
				end = start + this.number_of_posts;
			return this.filteredCategory.slice(start, end);
		},

		parsedCategories() {
			if (this.categories) {
				return JSON.parse(this.categories);
			} else {
				return null;
			}
		},

		parsedPrimaryCta() {
			if (this.no_search_results_primary_cta) {
				return JSON.parse(this.no_search_results_primary_cta);
			} else {
				return null;
			}
		},

		parsedSecondaryCta() {
			if (this.no_search_results_secondary_cta) {
				return JSON.parse(this.no_search_results_secondary_cta);
			} else {
				return null;
			}
		},

		parsedPosts() {
			if (this.posts) {
				return JSON.parse(this.posts);
			} else {
				return null;
			}
		},

		filteredCategory() {
			var vm = this;
			return vm.parsedPosts;
		},
	},

	watch: {
		currentFilter() {
			this.pageNumber = 0;
		},

		pageNumber() {
			this.loadPosts();
		},
	},

	methods: {
		nextPage() {
			this.pageNumber++;
		},
		prevPage() {
			this.pageNumber--;
		},

		number_posts_per_page() {
			let the_result = JSON.parse(this.posts_per_page);
			return the_result.number;
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		sleep(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		},

		async loadPosts() {
			this.busy = true;
			await this.sleep(300);
			window.scrollTo({ top: 0, behavior: 'smooth' });
			await this.sleep(2000);
			this.busy = false;
		},
	},

	components: {
		// PostTile,
		LoadingAnimation,
		PrimaryButton,
		SecondaryButton,
		TertiaryButton,
		ChevronRight,
	},

	created() {
		this.currentFilter = 'all';
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
		window.removeEventListener('resize', this.handleResize);
	},
	mounted() {
		this.handleResize();
	},
	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.search_listing {
	margin-top: 72px;
	padding-bottom: 96px;
	margin-bottom: 0;
	position: relative;

	@media (max-width: $mobile) {
		margin-top: 32px;
		padding-bottom: 32px;
	}

	.overlay {
		grid-column: span 12;
	}

	.container {
		// padding: 0 calc(var(--spacer) * 2);
		gap: 40px;
		/* max-width: 100%; */

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-template-columns: repeat(8, 1fr);
			gap: var(--gutter-tablet-desktop);
			// padding: 0 calc(var(--spacer) * 2);
		}

		@media (max-width: $tablet) and (orientation: landscape) {
			grid-template-columns: repeat(12, 1fr);
			gap: var(--gutter-tablet-desktop);
			// padding: 0 calc(var(--spacer) * 2);
		}

		@media (max-width: $mobile) {
			margin: 0;
			max-width: 100%;
			gap: var(--gutter-mobile);
			// padding: 0 calc(var(--spacer) * 1);
			grid-template-columns: repeat(4, 1fr);
		}

		.filter-cats {
			margin-bottom: 0;

			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: span 8;
				margin-bottom: 0;
			}

			@media (max-width: $tablet) and (orientation: landscape) {
				grid-column: span 12;
				margin-bottom: 0;
			}

			@media (max-width: $mobile) {
				grid-column: span 4;
				margin-bottom: 0;
			}
		}

		.search_results {
			grid-column: 3 / span 8;
			list-style: none;
			padding: 0;
			margin: 0;
			display: flex;
			flex-direction: column;
			flex-wrap: wrap;
			gap: 32px;

			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: 1 / span 8;
			}

			@media (max-width: $tablet) and (orientation: landscape) {
				grid-column: 1 / span 12;
			}

			@media (max-width: $mobile) {
				grid-column: 1 / span 4;
			}

			li {
				border-top: 1px solid var(--fpe-blue);
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				gap: 16px;
				padding-top: 16px;
				text-indent: 0;

				h3 {
					margin: 0;
					/* font: normal normal 600 var(--body-font-size) var(--primary-font-family); */
					color: var(--fpe-blue);
					text-indent: 0;
				}

				p {
					margin: 0 0 16px;
					text-indent: 0;
					color: var(--fpe-blue);
					font: normal normal normal 14px/20px var(--primary-font-family);

					&:last-of-type {
						margin-bottom: 0;
					}
				}

				.cta_wrapper {
					display: flex;
					flex-wrap: wrap;
					gap: 24px;
				}

				.site_button_secondary {
					width: fit-content;
					/* align-self: flex-end; */
				}
			}
		}

		.page-numbers {
			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: span 8;
			}

			@media (max-width: $tablet) and (orientation: landscape) {
				grid-column: span 12;
			}

			@media (max-width: $mobile) {
				grid-column: span 4;
			}
		}
	}

	.title {
		padding: 0 calc(var(--spacer) * 2);
		grid-column: 3 / span 8;
		margin: 0;
		text-align: center;
		color: var(--fpe-blue);
		line-height: unset;
		margin: 0;

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-column: 1 / span 8;
		}

		@media (max-width: $tablet) and (orientation: landscape) {
			grid-column: 1 / span 12;
		}

		@media (max-width: $mobile) {
			grid-column: 1 / span 4;
			padding: 0 calc(var(--spacer) * 1);
		}

		h3 {
			/* color: var(--fpe-blue); */
			padding-bottom: calc(var(--spacer) * 2);
			margin: 0;
			text-align: center;

			@media (max-width: $mobile) {
				text-align: center;
				font-size: 36px;
				line-height: 44px;
				padding-bottom: calc(var(--spacer) * 1);
			}
		}

		&::v-deep {
			h1,
			h2 {
				margin: 0;
				/* font: normal normal normal 40px/48px var(--primary-font-family-serif); */
				color: var(--fpe-blue);
			}
		}
	}

	.sort_banner {
		grid-column: 1 / span 12;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		width: 100%;

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-column: 1 / span 8;
		}

		@media (max-width: $mobile) {
			grid-template-columns: repeat(4, 1fr);
			grid-column: span 4;
		}

		.no-posts {
			padding: 0 calc(var(--spacer) * 2);
			grid-column: 3 / span 8;
			display: flex;
			justify-content: center;
			align-items: center;
			font: normal normal normal 14px/18px var(--primary-font-family);
			color: var(--fpe-blue);
			text-transform: unset;
			opacity: 1;

			@media (max-width: $mobile) {
				grid-column: 1 / span 4;
				padding: 0 0;
				flex-wrap: wrap;
				gap: 24px;
				width: 100%;
			}
		}

		.filter-sort {
			grid-column: 11 / span 2;
			display: flex;
			flex-wrap: wrap;
			flex-direction: row;
			list-style: none;
			margin: 0;
			padding: 0;
			justify-content: flex-end;
			position: relative;
			align-items: center;

			@media (max-width: $tablet) and (orientation: portrait) {
				grid-column: 10 / span 3;
			}

			&.clicked {
				&::before {
					transform: rotate(180deg);
					transition: 0.2s ease all;
				}
			}

			@media (max-width: $mobile) {
				grid-column: 1 / span 4;
				flex-wrap: wrap;
				grid-row: 1;
				margin-bottom: var(--gutter-tablet-desktop);
			}

			select {
				-webkit-appearance: none;
				-moz-appearance: none;
				appearance: none;
				background: var(--fpe-light-grey) 0% 0% no-repeat padding-box;
				background-image: url('data:image/svg+xml;base64,PHN2ZyBpZD0iQXJyb3ctc21hbGwiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTIgMTIiPgogIDxyZWN0IGlkPSJBcmVhIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9IiNmY2ZjZmMiIG9wYWNpdHk9IjAiLz4KICA8ZyBpZD0iSWNvbl9JQ09OX2ZlYXRoZXJfY2hldnJvbi1kb3duX1NJWkVfTUVESVVNX1NUWUxFX1NUWUxFMV8iIGRhdGEtbmFtZT0iSWNvbiBbSUNPTj1mZWF0aGVyL2NoZXZyb24tZG93bl1bU0laRT1NRURJVU1dW1NUWUxFPVNUWUxFMV0iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMy41KSI+CiAgICA8cGF0aCBpZD0iUGF0aCIgZD0iTTUsNy41bDUsNSw1LTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01IC03LjUpIiBmaWxsPSJyZ2JhKDAsMCwwLDApIiBzdHJva2U9IiM4YjZjMmIiIHN0cm9rZS13aWR0aD0iMS42NjciLz4KICA8L2c+Cjwvc3ZnPgo=');
				background-size: 14px 14px;
				background-position: calc(100% - 16px);
				border-radius: 22px;
				opacity: 1;
				padding: 12px calc(16px + 17px + 16px) 12px 16px;
				border: 0;
				outline: none;
				width: 100%;

				&:hover {
					background: var(--fpe-light-grey);
					background-image: url('data:image/svg+xml;base64,PHN2ZyBpZD0iQXJyb3ctc21hbGwiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTIgMTIiPgogIDxyZWN0IGlkPSJBcmVhIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9IiNmY2ZjZmMiIG9wYWNpdHk9IjAiLz4KICA8ZyBpZD0iSWNvbl9JQ09OX2ZlYXRoZXJfY2hldnJvbi1kb3duX1NJWkVfTUVESVVNX1NUWUxFX1NUWUxFMV8iIGRhdGEtbmFtZT0iSWNvbiBbSUNPTj1mZWF0aGVyL2NoZXZyb24tZG93bl1bU0laRT1NRURJVU1dW1NUWUxFPVNUWUxFMV0iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMy41KSI+CiAgICA8cGF0aCBpZD0iUGF0aCIgZD0iTTUsNy41bDUsNSw1LTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01IC03LjUpIiBmaWxsPSJyZ2JhKDAsMCwwLDApIiBzdHJva2U9IiM4YjZjMmIiIHN0cm9rZS13aWR0aD0iMS42NjciLz4KICA8L2c+Cjwvc3ZnPgo=');
					background-size: 14px 14px;
					background-position: calc(100% - 16px);
					background-repeat: no-repeat;
					cursor: pointer;
					transition: 0.2s ease all;
				}
			}

			h2 {
				margin-right: calc(var(--spacer) / 2);
				font-weight: bold;

				a {
					text-decoration: none;
					font-weight: bold;

					&:hover {
						cursor: pointer;
					}

					&.current {
						color: var(--fpe-blue);
					}
				}
			}
		}
	}

	.no_posts {
		grid-column: 3 / span 8;
		list-style: none;
		padding: 0;
		margin: 0;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		gap: 32px;

		&::v-deep {
			h2 {
				/* text-align: center; */
				color: var(--fpe-blue);
			}

			p {
				font: normal normal normal 14px/18px var(--primary-font-family);
			}

			ul {
				padding: 0 0 0 var(--spacer-mobile);

				li,
				ol {
					font: normal normal normal 14px/18px var(--primary-font-family);
				}
			}
		}

		&_message {
			text-align: center;

			p {
				&:first-of-type {
					margin: 0;
				}

				&:last-of-type {
					margin: 0;
				}
			}
		}

		&__cta_container {
			display: flex;
			flex-wrap: wrap;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			gap: var(--spacer);
		}

		@media (max-width: $tablet) and (orientation: portrait) {
			grid-column: 1 / span 8;
		}

		@media (max-width: $tablet) and (orientation: landscape) {
			grid-column: 1 / span 12;
		}

		@media (max-width: $mobile) {
			grid-column: 1 / span 4;
		}
	}

	.filter-cats {
		grid-column: span 12;
		display: flex;
		flex-direction: row;
		gap: var(--gutter-tablet-desktop);
		align-items: flex-end;
		flex-wrap: wrap;
		margin: 0;
		padding: 0;

		@media (max-width: $mobile) {
			grid-column: span 4;
			width: 100%;
			gap: var(--gutter-mobile);
			padding: var(--gutter-mobile) 0;
		}

		a {
			// background-image: url('data:image/svg+xml;base64,PHN2ZyBpZD0iQXJyb3ctc21hbGwiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTIgMTIiPgogIDxyZWN0IGlkPSJBcmVhIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9IiNmY2ZjZmMiIG9wYWNpdHk9IjAiLz4KICA8ZyBpZD0iSWNvbl9JQ09OX2ZlYXRoZXJfY2hldnJvbi1kb3duX1NJWkVfTUVESVVNX1NUWUxFX1NUWUxFMV8iIGRhdGEtbmFtZT0iSWNvbiBbSUNPTj1mZWF0aGVyL2NoZXZyb24tZG93bl1bU0laRT1NRURJVU1dW1NUWUxFPVNUWUxFMV0iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMy41KSI+CiAgICA8cGF0aCBpZD0iUGF0aCIgZD0iTTUsNy41bDUsNSw1LTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01IC03LjUpIiBmaWxsPSJyZ2JhKDAsMCwwLDApIiBzdHJva2U9IiM4YjZjMmIiIHN0cm9rZS13aWR0aD0iMS42NjciLz4KICA8L2c+Cjwvc3ZnPgo=');
			background-size: 14px 14px;
			background-position: calc(100% - 16px);
			border-radius: 22px;
			opacity: 1;
			padding: 12px calc(16px + 17px) 12px 16px;
			border: 0;
			outline: none;
			width: auto;

			&:disabled {
				opacity: 0.5;
			}

			&:hover {
				background: var(--fpe-blue);
				background-size: 8px 8px;
				background-position: calc(100% - 16px);
				background-repeat: no-repeat;
				cursor: pointer;
				transition: 0.2s ease all;
			}

			&.current {
				background: var(--fpe-dark-blue);
				background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQuNjQ5NjggMy45OTk5OEw3Ljk5OTk4IDAuNjQ5NjgxTDcuMzUwMyAwTDQgMy4zNTAzTDAuNjQ5Njk4IDBMMS42MjQ1NGUtMDUgMC42NDk2ODFMMy4zNTAzMiAzLjk5OTk4TDAgNy4zNTAzTDAuNjQ5NjgxIDcuOTk5OThMNCA0LjY0OTY2TDcuMzUwMzIgNy45OTk5OEw4IDcuMzUwM0w0LjY0OTY4IDMuOTk5OThaIiBmaWxsPSIjMjEyMTIxIi8+Cjwvc3ZnPgo=');
				background-size: 8px 8px;
				background-position: calc(100% - 16px);
				background-repeat: no-repeat;
				cursor: pointer;
				transition: 0.2s ease all;
			}
		}
	}

	ul.page-numbers {
		display: flex;
		flex-direction: row;
		gap: 0;
		width: auto;
		justify-content: center;
		align-items: center;
		padding: 0;
		margin: 16px 0 0;
		grid-column: 1 / span 12;

		@media (max-width: $mobile) {
			gap: 0;
			grid-column: span 4;
		}

		li {
			display: inline-flex;
			align-items: center;
			justify-content: center;

			.page-numbers {
				text-decoration: none;
				font: normal normal normal 16px/16px var(--primary-font-family);
				width: 32px;
				height: 32px;
				display: flex;
				justify-content: center;
				align-items: center;
				color: var(--fpe-blue);
				background: transparent;
				transition: 0.2s ease all;
				border-bottom: 1px solid transparent;
				/* border-radius: 50%; */

				&:hover {
					cursor: pointer;
					transition: 0.2s ease all;

					&:not(.next):not(.prev) {
						border-bottom: 1px solid var(--fpe-blue);
						color: var(--fpe-blue);
					}
				}

				@media (max-width: $mobile) {
					/* gap: 0;
					width: 24px;
					height: 24px; */
					/* font: normal normal normal 12px/16px var(--primary-font-family); */
				}

				&.current {
					transition: 0.2s ease all;
					border-bottom: 1px solid var(--fpe-blue);
					color: var(--fpe-blue);
					font: normal normal normal 16px/16px var(--primary-font-family);
				}

				&.next {
					position: relative;
					// overflow: hidden;
					text-indent: -9999px;
					content: '';
					width: 100px;

					span {
						display: block;
						font: normal normal normal 16px/16px var(--primary-font-family);
						text-indent: 0;
						position: absolute;
						right: 20px;
					}

					.arrow_container {
						position: absolute;
						right: 0;
						text-indent: 0;
						display: flex;
					}
				}

				&.prev {
					position: relative;
					// overflow: hidden;
					text-indent: -9999px;
					content: '';
					width: 100px;

					span {
						display: block;
						font: normal normal normal 16px/16px var(--primary-font-family);
						text-indent: 0;
						position: absolute;
						left: 20px;
					}

					.arrow_container {
						position: absolute;
						left: 0;
						text-indent: 0;
						display: flex;

						svg {
							transform: scaleX(-100%);
						}
					}
				}
			}
		}
	}

	.search_listing__item {
		&.not_visible {
			display: none;
		}

		&.visible {
			display: flex;
		}
	}
}

.slide-fade-enter-active {
	transition: opacity 0.2s ease;
	transition-delay: 0.3s;
}

.slide-fade-leave-active {
	transition: opacity 0.2s cubic-bezier(1, 0.5, 0.8, 1);
	// transition-delay: .4s;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SearchListing.vue